import React from 'react';
import {
  ContentRow,
  HeaderControls,
  HeaderSkeleton,
  InsightSkeletonCard,
  InsightsSkeletonRow,
  LoadingSkeleton,
  LoadingWrapper,
  OverviewSummarySkeleton,
  SectionGroup,
  SkeletonBlock,
  SummarySkeletonRow,
  TrackingSummarySkeleton,
} from './DashboardSkeleton.styles';

interface DashboardSkeletonProps {
  isTrackingReport: boolean;
  isMobileViewport: boolean;
}

const DashboardSkeleton: React.FC<DashboardSkeletonProps> = ({
  isTrackingReport,
  isMobileViewport,
}) => {
  return (
    <LoadingWrapper $isTrackingReport={isTrackingReport} aria-hidden>
      <LoadingSkeleton $isTrackingReport={isTrackingReport}>
        <HeaderSkeleton>
          <SkeletonBlock
            $width={isMobileViewport ? '56%' : '280px'}
            $height={isMobileViewport ? '28px' : '36px'}
          />
          <HeaderControls>
            <SkeletonBlock
              $width={isMobileViewport ? '100%' : '400px'}
              $height={isMobileViewport ? '48px' : '56px'}
            />
            <SkeletonBlock
              $width={isMobileViewport ? '100%' : '320px'}
              $height="40px"
            />
          </HeaderControls>
        </HeaderSkeleton>

        <SummarySkeletonRow>
          <TrackingSummarySkeleton $isTrackingReport={isTrackingReport} />
          <OverviewSummarySkeleton $isTrackingReport={isTrackingReport} />
        </SummarySkeletonRow>

        <InsightsSkeletonRow>
          <InsightSkeletonCard />
          {!isMobileViewport && <InsightSkeletonCard />}
          {!isMobileViewport && <InsightSkeletonCard />}
          {!isMobileViewport && <InsightSkeletonCard />}
        </InsightsSkeletonRow>

        <SectionGroup>
          <SkeletonBlock $height={isMobileViewport ? '260px' : '420px'} />
        </SectionGroup>

        <SectionGroup>
          <ContentRow>
            <SkeletonBlock $height="240px" />
            <SkeletonBlock $height="240px" />
          </ContentRow>
        </SectionGroup>

        <SectionGroup>
          <SkeletonBlock $height={isMobileViewport ? '240px' : '320px'} />
        </SectionGroup>
      </LoadingSkeleton>
    </LoadingWrapper>
  );
};

export default DashboardSkeleton;
